export const environment = {
  production: true,
  apiURL: 'https://sendy.njeasites.net/',
  imagePath: 'https://sendy.njeasites.net/api/revolt/upload.php',
  imageGetPath: 'https://sendy.njeasites.net/api/revolt/get_images.php',
  convertorPath: 'https://converter.njeasites.net',
  apiKey: 'TlrjJfVpgf38ZuS88mFQltsHLukwiet78HTbuQ17'
};
